import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class OfflineGuard implements CanActivate {
  
  constructor(private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!window.navigator.onLine) {
      this.router.navigateByUrl('offline-page');
    }

    return true;
  }
 
}
